export var DateFormatForLocale;
(function (DateFormatForLocale) {
    DateFormatForLocale["CA_DATE_FORMAT"] = "YYYY-M-D";
    DateFormatForLocale["EN_DATE_FORMAT"] = "MM/DD/YYYY";
})(DateFormatForLocale || (DateFormatForLocale = {}));
export var DateFragmentType;
(function (DateFragmentType) {
    DateFragmentType["DAYS"] = "days";
    DateFragmentType["YEARS"] = "years";
})(DateFragmentType || (DateFragmentType = {}));
export var DateTimeFormatForLocale;
(function (DateTimeFormatForLocale) {
    DateTimeFormatForLocale["TIME_FORMAT_24Hr"] = "HH:mm";
    DateTimeFormatForLocale["TIME_FORMAT_12Hr"] = "hh:mm A";
})(DateTimeFormatForLocale || (DateTimeFormatForLocale = {}));
//# sourceMappingURL=Enums.js.map